const userViewedTVAd =
  (typeof mntn !== "undefined" && mntn.is_viewable_verified_visit === "true") ||
  window.location.search.includes("show_ad_modal");

/**
 * Turn a normal function into an async function
 * @param {Function} func Function to make async
 * @param {Function} validator Determines if func output is ready to return
 * @param {Int} timeout How long we should wait in miliseconds
 * @returns {Promise} the output of func that has passed the validator
 */
async function asyncify(
  func,
  validator = (x) => Boolean(x),
  defaultReturn = null
) {
  let timeout = 10000;
  return new Promise((resolve, reject) => {
    const result = func();
    if (validator(result)) return resolve(result);
    const interval = setInterval(function () {
      const result = func();
      if (validator(result)) {
        resolve(result);
        clearInterval(interval);
      }
      if (timeout <= 0) resolve(defaultReturn);
      timeout -= 100;
    }, 100);
  });
}
async function asyncSelectAll(selector, root = document) {
  return asyncify(
    () => [...root.querySelectorAll(selector)],
    (result) => result.length > 0,
    []
  );
}
async function asyncSelect(selector, root = document) {
  return asyncify(
    () => root.querySelector(selector),
    (x) => Boolean(x)
  );
}
// +---------------+
// | Button Events |
// +---------------+
// Common Button Events
function fcButtonEvents({ target }) {
  // If element is in a button, run the event on the button element
  const buttonSelector = ["BUTTON", "A", "[data-fc-button]"];
  if (!buttonSelector.includes(target.nodeName)) {
    target = target.closest(buttonSelector.join());
    if (!target) return;
  }
  // In case we want to add styling when the button has been clicked
  target.classList.add("fc-btn--clicked");
  if (target.dataset.hide) {
    [...document.querySelectorAll(target.dataset.hide)].forEach((elem) =>
      elem.classList.add("fc-hide")
    );
  }
  if (target.dataset.show) {
    [...document.querySelectorAll(target.dataset.show)].forEach((elem) => {
      elem.classList.remove("fc-hide");
    });
  }
  if (target.dataset.openLightbox) {
    window.hasOpenedLightbox = true;
    // Open the lightbox
    const lightbox = document.querySelector(target.dataset.openLightbox);
    if (!lightbox) {
      console.error(target.dataset.openLightbox + " doesen't exist");
    } else if (!lightbox.classList.contains("fc-lightbox")) {
      actionFunctions
        .makeLightbox({
          lightbox
        })
        .then((lightbox) => lightbox?.dispatchEvent(new Event("open")));
    } else {
      lightbox?.dispatchEvent(new Event("open"));
    }
    const hideOtherCTAs = () => {
      console.log("hiding other full-story ctas");
      const fullStoryIds = ["#full-story", "#sitewide-full-story"];
      if (!fullStoryIds.includes(target.dataset.openLightbox)) return;
      const buttonSelector = `[data-open-lightbox="${target.dataset.openLightbox}"]`;
      // Hide all other buttons that open the same lightbox
      [...document.querySelectorAll(buttonSelector)].forEach((button) => {
        if (button === target || !button.matches(buttonSelector)) return;
        const container = button.parentElement.closest(".cta-container");
        (container ? container : button).classList.add("fc-hide");
      });
      // Save which button was clicked in local storage so we can hide it on page refresh
      let fcClickedCTAObj = JSON.parse(
        localStorage.getItem("fc-clicked-cta-" + testMetadata.id)
      );
      if (!fcClickedCTAObj) fcClickedCTAObj = {};
      fcClickedCTAObj[target.dataset.openLightbox] = {
        path: window.location.pathname,
        buttonIndex: [...document.querySelectorAll(buttonSelector)].findIndex(
          (button) => button === target
        )
      };
      localStorage.setItem(
        "fc-clicked-cta-" + testMetadata.id,
        JSON.stringify(fcClickedCTAObj)
      );
    };
    // If the lightbox is still open after 5 seconds, hide the other ctas
    setTimeout(() => {
      const htmlElem = document.documentElement;
      const lightboxIsOpem = htmlElem.classList.contains("fc-lightbox-open");
      if (lightboxIsOpem) hideOtherCTAs();
    }, 5000);
  }
  if (target.dataset.closeLightbox) {
    const lightbox = document.querySelector(target.dataset.closeLightbox);
    lightbox.dispatchEvent(new Event("close"));
  }
  if (target.dataset.replaceParentWith) {
    const parentElement = target.dataset.parent
      ? target.closest(target.dataset.parent)
      : target.parentElement;
    parentElement.innerHTML = target.dataset.replaceParentWith;
  }
  if (target.dataset.scrollTo) {
    const elem = document.querySelector(target.dataset.scrollTo);
    let block = "center";
    if (elem.offsetHeight > window.innerHeight + 100) {
      block = "start";
    }
    elem.scrollIntoView({ block, behavior: "smooth" });
  }
  if (target.dataset.setKey && target.dataset.toValue) {
    localStorage.setItem(target.dataset.setKey, target.dataset.toValue);
    asyncSelectAll(`[data-variable-name="${target.dataset.setKey}"]`).then(
      (variableElems) => {
        variableElems.forEach((variableElem) => {
          variableElem.innerHTML = target.dataset.toValue;
        });
      }
    );
  }
  if (target.dataset.goal && typeof ga !== "undefined") {
    const pageURL = window.location.hostname + window.location.pathname;
    ga("send", "event", {
      eventCategory: "Page interaction",
      eventAction: "click",
      eventLabel: target.dataset.goal + "(" + pageURL + ")"
    });
  }
  return false;
}
asyncSelect("body").then((body) =>
  body.addEventListener("click", fcButtonEvents)
);
// +--------------------------+
// | Custom code for the test |
// +--------------------------+
const testMetadata = {
  id: "r3c6a1"
};
const actions = [
  {
    type: "assign",
    arg1: "isMobile",
    arg3: "window.innerWidth < 750",
    contents: ""
  },
  {
    type: "assign",
    arg1: "isDesktop",
    arg3: "window.innerWidth > 750",
    contents: ""
  },
  {
    type: "append",
    arg1: "head",
    inline: "true",
    contents: /*html*/ `
              <style>
                #cta-lightbox {
                  text-align: center;
                  display: flex;
                  justify-content: center;
                  background: #fef7ec;
                  min-height: 80vh;
                }
              
                #cta-lightbox .fc-lightbox__close {
                  background: #fef7ec;
                }
              
                #cta-lightbox>p {
                  display: flex;
                  align-items: center;
                }
              
                #cta-lightbox img {
                  max-width: 400px;
                  height: auto;
                  object-fit: contain;
                  margin: 0 auto;
                }
              
                #cta-lightbox p:has(style) {
                  display: none;
                }
              </style>		
          `
  },
  {
    type: "makeLightbox",
    metadata: {
      customGoals: {
        Opened: 253,
        Bounced: 254,
        Converted: 255
      }
    },
    id: "cta-lightbox",
    autoOpen: "true",
    unless: "opened-cta-lightbox",
    contents: /*html*/ `
              <p><a class="fc-link" href="https://farmhousefreshgoods.com/collections/moisturizers/products/full-moon-dip-ageless-facial-mousse"><img src="//farmhousefreshgoods.com/cdn/shop/t/872/assets/goldenmoonad.jpg?v=30622999033197161911744837585" width="544" style="max-width: 80vw"></a></p>		
          `
  },
  {
    type: "loadCheckpointEvents",
    id: "loadCheckpointEvents",
    contents: ""
  },
  {
    type: "trackTestInfo",
    contents: ""
  }
];
const actionFunctions = {
  assign: ({ arg1: name, arg3: expression, dynamic = false }) => {
    console.log({ name, expression, dynamic });
    if (expression[0].match(/['"]/)) {
      expression = expression.slice(1, -1);
    }
    // Try for 10 seconds
    let attempts = 0;
    const assignVariable = () => {
      try {
        // Utility functions for assign
        const urlContains = (urlPart) =>
          window.location.pathname.includes(urlPart);
        // Get the value
        const value = eval(expression);
        if (typeof value === "undefined") throw "value is undefined";
        if (String(value) === "NaN") throw "value is NaN";
        window.localStorage.setItem(name, value);
        const varElems = document.querySelectorAll(
          `[data-variable-name="${name}"]`
        );
        [...varElems].forEach((span) => (span.innerHTML = value));
        if (dynamic) setTimeout(assignVariable, 1000);
      } catch (error) {
        if (attempts <= 20 || dynamic) {
          attempts++;
          setTimeout(assignVariable, 500);
        } else {
          console.warn("Assign", name, "to", expression, "failed");
        }
      }
    };
    assignVariable();
  },
  append: async ({ arg1: selector, contents }) => {
    const elems = await asyncSelect(selector);
    elems.insertAdjacentHTML("beforeEnd", contents);
  },
  makeLightbox: ({ id, contents, metadata, autoOpen = false }) => {
    const trackOpen = () => {
      console.log("Opened " + id, { metadata });
      // Hotjar tracking
      if (typeof hj !== "undefined") {
        hj("event", testMetadata.id + "-open-lightbox-" + id);
        hj("event", "open-lightbox");
      }
      // CrazyEgg Tracking
      if (typeof CE2 !== "undefined") {
        CE2.addTag(testMetadata.id + "-open-lightbox-" + id);
        CE2.addTag("open-lightbox");
      }
      // Microsoft Clarity Tracking
      if (window.clarity) {
        window.clarity("set", testMetadata.id + "-open-lightbox-" + id, true);
        window.clarity("set", "open-lightbox", true);
      }
      // Universal Google Analytics (Remove after June 2023)
      if (typeof ga !== "undefined") {
        ga("send", "event", {
          eventCategory: "Page interaction",
          eventAction: "click",
          eventLabel: testMetadata.id + "-open-lightbox-" + id
        });
      }
      // VWO tracking
      window._vis_opt_queue = window._vis_opt_queue || [];
      window._vis_opt_queue.push(function () {
        _vis_opt_goal_conversion(metadata.customGoals["Opened"]);
      });
      // Queue the conversion goal for if/when the user converts
      const conversionGoals =
        localStorage.getItem("fc_conversion_goals")?.split(",") || [];
      localStorage.setItem(
        "fc_conversion_goals",
        [...conversionGoals, metadata.customGoals["Converted"]].join(",")
      );
    };
    const trackBounce = () => {
      console.log("Bounced " + id);
      // VWO tracking
      window._vis_opt_queue = window._vis_opt_queue || [];
      window._vis_opt_queue.push(function () {
        _vis_opt_goal_conversion(metadata.customGoals["Bounced"]);
      });
    };
    async function lightboxEvents(lightbox) {
      const container = lightbox.parentElement;
      // This script always loads in the header, so wait till we can access body
      const body = await asyncSelect("body");
      const openLightbox = () => {
        trackOpen();
        // For conditionally doing things based on if the lightbox has been
        // opened on other pages
        localStorage.setItem("opened-" + id, true);
        // So back button closes lightbox
        history.pushState({}, "", "#" + id);
        // Move lightbox to the body elem so that it can always show above
        // other high z-index items
        if (container.parentElement !== body) {
          document.body.appendChild(container);
        }
        // Open the lightbox
        container.classList.remove("fc-hide");
        // Always scroll to the top of open lightboxes
        container.scrollTop = 0;
        var scrollBarWidth = window.innerWidth - body.offsetWidth;
        document.body.style.marginRight = scrollBarWidth + "px";
        document.documentElement.classList.add("fc-lightbox-open");
        // Listen for bounces
        const openTime = new Date() * 1;
        const listenForBounce = () => {
          const closeTime = new Date() * 1;
          if (closeTime - openTime < 5000) {
            trackBounce();
          }
          lightbox.removeEventListener("close", listenForBounce);
        };
        lightbox.addEventListener("close", listenForBounce);
      };
      const closeLightbox = () => {
        history.pushState({}, "", window.location.pathname);
        document.body.style.marginRight = "0px";
        lightbox.classList.add("fc-fade-out");
        setTimeout(() => {
          container.classList.add("fc-hide");
          lightbox.classList.remove("fc-fade-out");
          // Rewrite inner HTML so that videos are paused
          [...lightbox.querySelectorAll("iframe")].forEach((video) => {
            video.outerHTML = video.outerHTML;
          });
        }, 200);
        // If there's no open lightboxes, enable scrolling again
        const openLightboxes = document.querySelectorAll(
          ".fc-lightbox-overlay:not(.fc-hide)"
        );
        if (openLightboxes.length === 1) {
          document.documentElement.classList.remove("fc-lightbox-open");
        }
      };
      // Open the lightbox immediatly if the hash is set
      if (window.location.hash.split("?")[0] === "#" + id) openLightbox();
      // Listen for opening the lightbox
      lightbox.addEventListener("open", openLightbox, false);
      // Events for exiting the lightbox
      lightbox.addEventListener("close", closeLightbox, false);
      container.addEventListener("click", ({ target }) => {
        if (target === container) lightbox.dispatchEvent(new Event("close"));
      });
      // Only do this once
      if (!window.haspopstateLightboxEvent) {
        window.haspopstateLightboxEvent = true;
        // When we press the back button, close any
        window.addEventListener(
          "popstate",
          () => {
            if (window.location.hash === "") {
              const openLightboxElement = document.querySelector(
                ".fc-lightbox-overlay:not(.fc-hide) .fc-lightbox"
              );
              openLightboxElement?.dispatchEvent(new Event("close"));
            }
          },
          false
        );
      }
    }
    function preloadImages(...images) {
      console.log("Preloading images...");
      window.images = window.images || [];
      for (var i = 0; i < images.length; i++) {
        const image = new Image();
        image.src = images[i];
        window.images.push(image);
      }
    }
    async function makeLightbox({ contents, id, style }) {
      const lightbox = document.createElement("div");
      lightbox.innerHTML = contents;
      lightbox.id = id;
      lightbox.classList.remove("fc-hide");
      lightbox.classList.add("fc-lightbox");
      let container = document.createElement("div");
      container.classList.add(id + "-container");
      container.setAttribute("style", style);
      container.classList.add("fc-hide", "fc-lightbox-overlay");
      const closeButtonSVG = /*static*/ `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M390,308l-7.72,7.72-2.63-2.63,7.72-7.72-8.27-8.27,2.8-2.8,8.27,8.27,7.72-7.72,2.63,2.63-7.72,7.72,8.27,8.27-2.8,2.8Z" transform="translate(-379.1 -294.3)"></path></svg>`;
      const closeButtonHTML = /*static*/ `<button class="fc-lightbox__close" onclick="event.stopPropagation(); this.closest('.fc-lightbox').dispatchEvent(new Event('close'));" aria-label="Close">${closeButtonSVG}</button>`;
      // lightbox.insertAdjacentHTML("afterbegin", "<br />");
      lightbox.insertAdjacentHTML("afterbegin", closeButtonHTML);
      asyncSelect("body").then((body) => body.appendChild(container));
      container.appendChild(lightbox);
      await lightboxEvents(lightbox);
      setTimeout(
        () => preloadImages(...lightbox.querySelectorAll("img")),
        5000
      );
      return lightbox;
    }
    // Make the lightbox
    makeLightbox({ id, contents: contents });
    if (autoOpen) {
      setTimeout(() => {
        const lightbox = document.getElementById(id);
        lightbox.dispatchEvent(new Event("open"));
      }, parseInt(autoOpen) * 1000 || 0);
    }
  },
  loadCheckpointEvents: async () => {
    let checkpointObserver = new IntersectionObserver(function (checkpoints) {
      checkpoints.forEach(function (checkpoint) {
        if (checkpoint.isIntersecting) {
          let checkpointElem = checkpoint.target;
          checkpointElem.classList.add("triggered");
          console.log("Triggered", checkpointElem.dataset.id);
          window._vis_opt_queue = window._vis_opt_queue || [];
          window._vis_opt_queue.push(() => {
            _vis_opt_goal_conversion(parseInt(checkpointElem.dataset.id));
          });
          checkpointObserver.unobserve(checkpointElem);
        }
      });
    });
    /** Now observe all the non-loaded images using the observer we have setup above **/
    const addObservers = async () => {
      const checkpointElems = await asyncSelectAll(".fc-checkpoint");
      checkpointElems.forEach((elem) => {
        checkpointObserver.observe(elem);
      });
    };
    addObservers();
    setTimeout(addObservers, 4000);
  },
  trackTestInfo: () => {
    if (typeof hj !== "undefined") hj("event", "fc-test-" + testMetadata.id);
    if (typeof CE2 !== "undefined") CE2.addTag("fc-test-" + testMetadata.id);
    if (window.clarity)
      window.clarity("set", "fc-test-" + testMetadata.id, true);
  }
};
class ChangeQueue {
  constructor() {
    this.testCSS = "";
  }
  async do(changes) {
    const changeFunctions = changes.map((change) =>
      this.getChangeFunction(change)
    );
    for (let i = 0; i < changes.length; i++) {
      const change = changes[i];
      const actionFunction = changeFunctions[i];
      this.doChange({ change, actionFunction });
    }
    this.afterChanges();
  }
  async doChange({ change, actionFunction }) {
    if (!this.shouldDoChange(change)) return;
    if (change.wait) {
      await new Promise((resolve) => {
        setTimeout(resolve, parseInt(change.wait) * 1000);
        // Once we've waited to add the change, enforce choreographed button rules
        setTimeout(choreographedButtonsEvents, 100);
      });
    }
    const response = actionFunction(change);
    // Action function can update change settings
    change = { ...change, ...response };
    if (change.css) this.testCSS += change.css;
    if (change.js) {
      change.js(change);
    }
  }
  evalLocalStorageBool(varString) {
    if (varString.includes(" and ")) {
      return varString
        ?.split(" and ")
        .map((varName) => localStorage.getItem(varName))
        .every((value) => value === "true");
    }
    return varString
      ?.split(" or ")
      .map((varName) => localStorage.getItem(varName))
      .includes("true");
  }
  // Don't do the change when the "if" or "unless" attributes doesn't pass
  shouldDoChange(change) {
    if (change.if && !this.evalLocalStorageBool(change.if)) return false;
    if (change.unless && this.evalLocalStorageBool(change.unless)) return false;
    if (change.onPath && change.onPath !== window.location.pathname)
      return false;
    return true;
  }
  getChangeFunction(change) {
    function actionFunction() {
      try {
        if (change.inline) {
          // All inline changes don't have p elements
          change.contents = change.contents.replace(/\<\/? *[pP][^>]*\>/g, "");
        }
        if (change.delay) {
          setTimeout(
            () => actionFunctions[change.type](change),
            change.delay * 1000
          );
        } else {
          return actionFunctions[change.type](change);
        }
      } catch (error) {
        console.error("Error with", change, { error });
      }
    }
    return actionFunction;
  }
  // What to run once all test changes have been
  afterChanges() {
    // Add variables
    asyncSelectAll("[data-variable-name]").then((variableElems) => {
      variableElems.forEach((variableElem) => {
        const { variableName } = variableElem.dataset;
        const value = localStorage.getItem(variableName);
        if (value) variableElem.innerHTML = value;
      });
    });
    // Evaluate if statements
    asyncSelectAll("[data-if]").then((ifElems) => {
      ifElems.forEach((ifElem) => {
        if (this.evalLocalStorageBool(ifElem.dataset.if))
          ifElem.classList.remove("fc-hide");
      });
    });
    asyncSelectAll("[data-unless]").then((unlessElems) => {
      unlessElems.forEach((unlessElem) => {
        if (this.evalLocalStorageBool(unlessElem.dataset.if))
          unlessElem.classList.remove("fc-hide");
      });
    });
    // Add Injected CSS
    document.head.insertAdjacentHTML(
      "beforeEnd",
      `<style id="fc-injected-style" type="text/css">${this.testCSS}</style>`
    );
  }
}
function choreographedButtonsEvents() {
  // Hide all other buttons that open the same lightbox
  const fcClickedCTA = JSON.parse(
    localStorage.getItem("fc-clicked-cta-" + testMetadata.id)
  );
  if (!fcClickedCTA) {
    // Show all ctas
    const showAllCTAs = () =>
      asyncSelectAll(`[data-open-lightbox]:not(.fc-show)`).then((buttons) => {
        buttons.forEach((button) => {
          button.classList.add("fc-show");
          button.closest(".cta-container")?.classList.add("fc-show");
        });
      });
    showAllCTAs();
    setTimeout(showAllCTAs, 1000);
    return;
  }
  Object.keys(fcClickedCTA).forEach((lightboxSelector) => {
    asyncSelectAll(`[data-open-lightbox="${lightboxSelector}"]`).then(
      (buttons) => {
        buttons.forEach((button, i) => {
          if (
            i === fcClickedCTA[lightboxSelector].buttonIndex &&
            window.location.pathname === fcClickedCTA[lightboxSelector].path
          ) {
            button.classList.add("fc-show");
            button.closest(".cta-container")?.classList.add("fc-show");
          }
        });
      }
    );
  });
}

function runModal() {
  console.log("runModal");
  const changeQueue = new ChangeQueue(actionFunctions);
  changeQueue.do(actions).then(async () => {
    // Post changes events
    choreographedButtonsEvents();
  });

  const css = /*css*/ `
@media (max-width: 750px) {
    .hide-on-mobile {
      display: none !important;
    }
  }
  @media (min-width: 750px) {
    .hide-on-desktop {
      display: none !important;
    }
  }
  
  /* Utility class for hiding/showing things easily */
  html body .fc-hide {
    display: none !important;
  }
  
  .cta-container:has([data-open-lightbox*="full-story"]):not(.fc-show),
  [data-open-lightbox*="full-story"]:not(.fc-show) {
    display: none !important;
  }
  
  ol li:has(> [data-open-lightbox*="full-story"]:not(.fc-show)),
  ol li:has(> [data-open-lightbox*="full-story"].fc-hide) {
    display: none;
  }
  
  /* Padding for lightbox and inlineLFSP */
  :is(.fc-lightbox, .inline-lfsp) p,
  :is(.fc-lightbox, .inline-lfsp) h1,
  :is(.fc-lightbox, .inline-lfsp) h2,
  :is(.fc-lightbox, .inline-lfsp) h3,
  :is(.fc-lightbox, .inline-lfsp) h4 {
    padding: 0 var(--fc-side-padding);
  }
  .fc-lightbox h1 {
      margin-top: 1em;
  }
  :is(.fc-lightbox, .inline-lfsp) ul,
  :is(.fc-lightbox, .inline-lfsp) ol {
    padding-left: var(--fc-side-padding);
    padding-right: var(--fc-side-padding);
    color: inherit;
  }
  .fc-lightbox p,
  .fc-lightbox li {
    font-size: var(--fc-font-size);
    color: inherit;
  }
  :is(.fc-lightbox, .inline-lfsp) li > p {
    padding: 0 !important;
    margin: 0;
  }
  :is(.fc-lightbox, .inline-lfsp) span {
    font-size: inherit;
  }
  :is(.fc-lightbox, .inline-lfsp) img {
    max-width: 100%;
  }html, body { --fc-lightbox-width: 750px; --fc-lightbox-background: #ffffff; --fc-close-button-padding: 10px; }
  @keyframes fcSlideIn { 
    0% { opacity: 0.2; margin-top: 30px; }
    100% { opacity: 1; margin-top: 0px; }
  }
  @keyframes fcSlideOut { 
    0% { opacity: 1; margin-top: 0px; }
    100% { opacity: 0; margin-top: 30px; }
  }
  html.fc-lightbox-open.fc-lightbox-open.fc-lightbox-open, html.fc-lightbox-open.fc-lightbox-open.fc-lightbox-open > body { overflow: hidden; }
  html.fc-lightbox-open.fc-lightbox-open.fc-lightbox-open #gorgias-chat-container, html.fc-lightbox-open body > [style*="z-index"] { display: none; }
  .fc-lightbox-overlay { z-index: 999999999; background: rgba(0, 0, 0, 0.8); height: 100%; width: 100%; box-sizing: border-box; top: 0px; overflow: auto; padding-bottom: 5px; display: flex; position: fixed; flex-flow: wrap; align-items: center; justify-content: center; }
  .fc-lightbox { color: rgb(0, 0, 0); display: block; box-sizing: border-box; background: var(--fc-lightbox-background); width: calc(100% - 10px); overflow: hidden auto; padding: 0px; margin: 5px 5px 20px; max-width: var(--fc-lightbox-width); border-radius: 12px; animation-name: fcSlideIn; animation-iteration-count: 1; animation-timing-function: linear; animation-duration: 0.3s; }
  .fc-lightbox.fc-fade-out { animation-name: fcSlideOut; animation-iteration-count: 1; animation-timing-function: linear; animation-duration: 0.3s; }
  @media (min-width: 750px) {
    .fc-lightbox__close { cursor: pointer; z-index: 2147483647; border: none; line-height: 0; background: transparent; position: fixed; left: calc( 50vw + var(--fc-lightbox-width) / 2 ); transform: translateX(-100%); border-radius: 0px 12px 0px 0px; min-width: unset; box-shadow: unset; padding: 10px; }
    .fc-lightbox__close svg { width: 20px; fill: var(--fc-accent, red); background: var(--fc-lightbox-background); padding: 10px; border-radius: 4px; box-sizing: content-box !important; }
  }
  @media (min-width: 750px) {
    :root { --fc-font-size: 20px; --fc-side-padding: 40px; }
  }
  @media (max-width: 750px) {
    :root { --fc-side-padding: 10px; --fc-font-size: 18px; }
    .fc-lightbox-overlay { flex-flow: row; align-items: unset; padding: 8px 8px 0px; }
    .fc-lightbox { width: 100%; margin: 0px; left: 0px; border-radius: 4px 4px 0px 0px; padding-top: 45px; max-height: 100%; transform: none; }
    .fc-lightbox__close { position: fixed; z-index: 1000000; width: calc(100% - 16px); font-size: 1.2em; border-top: 0px; border-right: 0px; border-left: 0px; border-image: initial; padding: 8px; left: 8px; top: 8px; margin-top: 0px; background: var(--fc-lightbox-background); border-bottom: solid var(--fc-accent, red); color: var(--fc-accent, red); height: 45px; border-radius: 4px 4px 0px 0px; animation-name: fcSlideIn; animation-iteration-count: 1; animation-timing-function: linear; animation-duration: 0.3s; }
    .fc-lightbox.fc-fade-out > .fc-lightbox__close { animation-name: fcSlideOut; animation-iteration-count: 1; animation-timing-function: linear; animation-duration: 0.3s; }
    .fc-lightbox__close svg { display: none; }
    .fc-lightbox__close::before { content: "× Close"; }
  }
  .single-column-table { margin: 0 var(--fc-side-padding) 1em; padding: 1em 0px; }
  .single-column-table > p:not([style*="margin-left"]) { margin-left: 0px !important; }
  .single-column-table p:first-of-type { margin-top: 0px; }
  .single-column-table p:last-of-type { margin-bottom: 0px; }
  .fc-lightbox > :first-child + :is(h1, h2, p) { margin-top: 1em; }
  .fc-lightbox div:has(> img) + p { margin-top: 1em; }
  .fc-lightbox p:has([data-open-lightbox]) { text-align: center; }
  .fc-lightbox [data-close-lightbox] { margin-top: 0px; margin-bottom: var(--fc-side-padding); }
  /* shortcodes */
   
  /* endshortcodes */
  .ProductSections__slider { overflow: hidden; }
  .product__price p { display: inline; font-size: 20px; margin-left: 6px; }
  button > p { margin: 0px; }
  .fc-container { max-width: 750px; margin: 0px auto; padding: 0px 40px 40px; }
  .fc-lightbox-open #velaro-container { display: none; }
  .blurred-section--content :is(h1, h2, h3, h4) { color: rgb(0, 0, 0) !important; }
  .blurred-section--content p { line-height: 1.4em; font-weight: 600; color: rgb(0, 0, 0) !important; }
  @media (min-width: 770px) {
    .product-single__title + p + p { text-align: left !important; }
    .inverse-fresh-row .text-wrap { padding-right: 100px; }
  }
  .cocoen { position: relative; overflow: visible; }
  .cocoen .drag-this-line { position: absolute; top: 0px; right: 25px; transform: translateY(-80%) translateX(60%); }
  .cocoen { margin-top: 20px; }
  @media (max-width: 640px) {
    .cocoen .drag-this-line { transform: translateY(-60%) translateX(-4%); }
    .yotpo-bottomline { margin: 0px auto; display: block !important; float: unset !important; text-align: center !important; }
    .yotpo-bottomline .yotpo-stars .yotpo-icon { display: inline !important; float: unset !important; }
  }
  .cocoen .drag-this-line img { width: 150px; }
  #desktop-blocked-description { padding-bottom: 60px; }
  .fc-lightbox blockquote { font-style: normal; display: block; border-left: 3px solid rgb(123, 154, 98); margin: 0 var(--fc-side-padding); font-family: FuturaPT, sans-serif; padding: 1em !important; }
  .fc-lightbox blockquote p { font-weight: 400; padding: 0px !important; }
  .blurred-section--content p { font-family: FuturaPT, sans-serif; font-weight: 400; font-size: 16px; margin-bottom: 1.2em !important; line-height: 1.4em !important; }
  .blurred-section:not(.fc-hide) ~ .cocoen > .drag-this-line { display: none; }
  .cocoen-drag::before { width: 14px; height: 14px; margin-top: -7px; border-radius: 50%; background: rgb(255, 255, 255); }
  .glider-slide img, .glider-slide p { margin: 0px auto; display: block; }
  .glider-slide img { max-width: 350px; margin-bottom: 24px; }
  .glider-slide p { max-width: 500px; }
  .product-single__meta button:not(.fc-hide) + .yotpo { margin-top: 0.4em; }
  .fc-lightbox :is(p, li, h1, h2, h3) { color: rgb(144, 134, 132) !important; }
  .btn--secondary--inverse { color: rgb(255, 255, 255); border: 1px solid rgb(144, 134, 132); background-color: rgb(144, 134, 132); }
  .hp-testimonials .testimonials-wrapper { padding-bottom: 0px !important; }
  .hp-testimonials { margin-bottom: 30px; }
  .fc-lightbox .fc-cocoen > div img { height: 100%; object-fit: cover; object-position: left center; }
  .fc-lightbox table { background: rgb(255, 255, 255); border-collapse: collapse; margin-bottom: 18px; }
  .fc-lightbox table tr { border: none; background: rgb(253, 247, 240) !important; }
  .fc-lightbox table tr td { background: transparent; vertical-align: top; }
  .fc-lightbox table p { padding: 0px !important; }
  .product-single__description h3 { margin-top: 0em; }
  .product__price .fc-link { font-size: 14px; }
  .fc-link { text-decoration: underline; }
  .fc-lightbox :is(h1, h2, h3), .fc-lightbox :is(h1, h2, h3) > * { font-size: 26px !important; color: rgb(144, 134, 132) !important; }
  .ProductInfo__slider-title, .ProductInfo__BeforeAfter-title { padding-top: 1em; padding-bottom: 0.1em; }
  .fc-lightbox :is(h1, h2, h3, h4) { padding-top: 1.2em; padding-bottom: 0.2em; }
  @media (min-width: 750px) {
    .fc-lightbox__close { padding: 30px; }
  }
  .fc-lightbox h2 { font-size: 32px; }
  .fc-container { display: block; max-width: 1200px; margin: 0px auto; padding: 40px; }
  @media (max-width: 750px) {
    .product-single__meta { margin-top: 34px; }
  }
  .h2.product-single__title { margin-top: 16px !important; }
  .fc-lightbox .cocoen { margin-top: 20px; }
  .glider-next, .glider-prev { color: rgb(123, 154, 98); }
  [data-open-lightbox].btn-secondary { background: transparent; color: rgb(123, 154, 98); padding-left: 0px; padding-right: 0px; font-size: 16px; }
  [data-open-lightbox].btn-secondary:hover { color: rgb(123, 154, 98); background: transparent !important; }
  .fc-lightbox .video-modal-cnt { min-height: calc(100vh - 100px); }
  [data-open-lightbox="#video-modal"] > div { background-size: contain !important; }
  html body .fc-banner a { color: rgb(255, 255, 255) !important; }
  @media (max-width: 750px) {
    .center-on-mobile { text-align: center; }
  }
  .btn-secondary { letter-spacing: 0.2em !important; }
  .cta-lightbox-container {
      background: rgba(0,0,0,0.3);
  }
    `;
  document.head.insertAdjacentHTML("beforeend", `<style>${css}</style>`);
}

if (userViewedTVAd) runModal();